import type { ScheduleTranslation } from './schedule.en'

export const scheduleEs: ScheduleTranslation = {
  common: {
    after: `Después`,
    cancel: `Cancelar`,
    clear: `Limpiar`,
    closed: `Cerrado`,
    create: `Crear`,
    daily: `Diario`,
    delete: `Eliminar`,
    deleteError: {
      inUseGeneric: `No se puede eliminar este horario porque está en uso por un cuadro de mandos. Quítalo del cuadro de mandos e inténtalo de nuevo.`,
      inUseMultiple: `No se puede eliminar este horario porque está en uso en estos cuadros de mandos: {{switchboardNames}}. Quítalo de esos cuadros de mandos e inténtalo de nuevo.`,
      inUseSingle: `No se puede eliminar este horario porque está en uso en este cuadro de mandos: {{switchboardNames}}. Quítalo de ese cuadro de mandos e inténtalo de nuevo.`,
      listWithMore: `{{visibleNames}} y {{remaining}} más`,
    },
    description: `Descripción`,
    edit: `Editar`,
    from: `de`,
    holiday: `Festivo`,
    monthly: `Mensual`,
    name: `Nombre`,
    never: `Nunca`,
    onDate: `En fecha`,
    routing: `Enrutamiento`,
    save: `Guardar`,
    saving: `Guardando...`,
    timeZone: `Zona horaria`,
    to: `a`,
    validationErrorTitle: `Error de validación`,
    weekdayShort: {
      fri: `Vie`,
      mon: `Lun`,
      sat: `Sáb`,
      sun: `Dom`,
      thu: `Jue`,
      tue: `Mar`,
      wed: `Mié`,
    },
    weekdayLong: {
      fri: `Viernes`,
      mon: `Lunes`,
      sat: `Sábado`,
      sun: `Domingo`,
      thu: `Jueves`,
      tue: `Martes`,
      wed: `Miércoles`,
    },
    weekly: `Semanal`,
    yearly: `Anual`,
  },
  detail: {
    actions: {
      deleteScheduleModalTitle: `Eliminar horario`,
      deleteScheduleTitle: `Eliminar horario`,
      editScheduleTitle: `Editar horario`,
    },
    currentRouting: `Enrutamiento actual:`,
    error: `Error`,
    header: {
      breadcrumbCurrent: `Editar horarios`,
      breadcrumbRoot: `Horarios`,
    },
    hoursView: {
      calendar: `Calendario`,
      list: `Lista`,
    },
    loading: `Cargando horario...`,
    notFound: {
      description: `El horario que buscas no existe.`,
      title: `Horario no encontrado`,
    },
    toast: {
      createOverrideFailedTitle: `No se pudo crear la excepción`,
      createWeeklyHoursFailedTitle: `No se pudieron crear las horas semanales`,
      deleteEventFailedTitle: `No se pudo eliminar el evento`,
      deleteScheduleFailedTitle: `No se pudo eliminar el horario`,
      eventDeleted: `Evento eliminado correctamente`,
      eventsUpdatedDescription: `Zona horaria actualizada para {{count}} evento(s)`,
      eventsUpdatedTitle: `Eventos actualizados`,
      failedTitle: `Error`,
      genericError: `Ocurrió un error`,
      holidaysAddFailed: `No se pudieron agregar {{count}} festivo(s)`,
      holidaysAddedSuccess: `Se agregaron {{count}} festivo(s) correctamente`,
      holidaysAddedWithFailures: `Se agregaron {{successCount}} festivo(s) correctamente ({{errorCount}} con error)`,
      loadEventsFailedDescription: `Ocurrió un error al cargar los eventos`,
      loadEventsFailedTitle: `No se pudieron cargar los eventos del horario`,
      loadScheduleFailedDescription: `Ocurrió un error al cargar el horario`,
      loadScheduleFailedTitle: `No se pudo cargar el horario`,
      overrideCreated: `Excepción creada correctamente`,
      overrideUpdated: `Excepción actualizada correctamente`,
      scheduleDeleted: `Horario eliminado correctamente`,
      scheduleUpdated: `Horario actualizado correctamente`,
      successTitle: `Éxito`,
      updateOverrideFailedTitle: `No se pudo actualizar la excepción`,
      updateScheduleFailedTitle: `No se pudo actualizar el horario`,
      updateWeeklyHoursFailedTitle: `No se pudieron actualizar las horas semanales`,
      weeklyHoursCreated: `Horas semanales creadas correctamente`,
      weeklyHoursUpdated: `Horas semanales actualizadas correctamente`,
    },
  },
  holidays: {
    actions: {
      addWithCount: `Agregar festivos ({{count}})`,
    },
    common: {
      unknown: `Desconocido`,
    },
    customPrompt: {
      link: `Configura tus propios horarios especiales`,
      prefix: `¿No ves el festivo que buscas?`,
    },
    empty: `No hay festivos predefinidos disponibles`,
    error: {
      failedToLoad: `No se pudieron cargar los festivos`,
    },
    loading: `Cargando festivos...`,
    modal: {
      description: `Selecciona los festivos predefinidos que quieres agregar a tu lista de excepciones. Puedes ajustar las horas de cada festivo editando el evento después de crearlo.`,
      title: `Agregar festivos predefinidos`,
    },
    submitting: `Actualizando tu horario, esto tardará solo un momento.`,
    table: {
      holiday: `Festivo`,
      nextOccurrence: `Próxima ocurrencia`,
    },
    validation: {
      noneSelectedDescription: `Selecciona al menos un festivo para agregar`,
      noneSelectedTitle: `No hay festivos seleccionados`,
    },
  },
  list: {
    card: {
      lastUpdated: `Última actualización`,
    },
    common: {
      notAvailable: `N/D`,
    },
    delete: `Eliminar`,
    deleteTitle: `Eliminar horario`,
    empty: `No se encontraron horarios`,
    grid: {
      errorTitle: `Error`,
    },
    hoursVary: `El horario varía`,
    loading: `Cargando horarios...`,
    newSchedule: `Nuevo horario`,
    noPermission: `No tienes permiso para acceder a los horarios.`,
    noSchedules: `No se encontraron horarios`,
    noSchedulesDescription: `Haz clic en agregar nuevo horario para comenzar a definir tu disponibilidad`,
    pagination: {
      all: `Todos`,
      jumpToPage: `Ir a la página {{page}}`,
      nextPage: `Página siguiente`,
      previousPage: `Página anterior`,
      resultsPerPage: `Resultados por página:`,
    },
    status: {
      closed: `Cerrado`,
      holiday: `Festivo`,
      openNow: `Abierto ahora`,
    },
    subtitle: `Ver y administrar configuraciones de horarios`,
    title: `Horarios`,
    toast: {
      createFailed: `Error al crear`,
      createFailedDescription: `No se pudo crear el horario`,
      createSuccess: `Horario creado`,
      createSuccessDescription: `El horario se creó correctamente.`,
      deleteFailed: `Error al eliminar`,
      deleteFailedDescription: `No se pudo eliminar el horario`,
      deleteSuccess: `Horario eliminado`,
      deleteSuccessDescription: `El horario se eliminó correctamente.`,
    },
    unavailable: `No disponible`,
  },
  modal: {
    create: {
      cancel: `Cancelar`,
      defaultWeeklyHoursLabel: `Incluir horas semanales predeterminadas`,
      descriptionLabel: `Descripción`,
      descriptionPlaceholder: `Descripción opcional para este horario`,
      nameLabel: `Nombre`,
      namePlaceholder: `Horario comercial`,
      saveSchedule: `Guardar horario`,
      saving: `Guardando...`,
      timeZoneLabel: `Zona horaria`,
      title: `Nuevo horario`,
      validationNameRequired: `Ingresa un nombre para el horario`,
      validationTitle: `Validación`,
    },
    deleteConfirmation: {
      cancel: `Cancelar`,
      confirm: `Eliminar`,
      defaultBodyWithItemPrefix: `¿Seguro que deseas eliminar `,
      defaultBodyWithItemSuffix: `? Esta acción no se puede deshacer.`,
      defaultBodyWithoutItem: `¿Seguro que deseas eliminar este elemento? Esta acción no se puede deshacer.`,
      defaultTitle: `Eliminar elemento`,
    },
    editSchedule: {
      applyTimezoneChanges: `Aplicar cambios de zona horaria a:`,
      customEventsHelp: `Desmarca esta opción si no deseas actualizar la zona horaria de los eventos personalizados existentes.`,
      customEventsWithCount: `Eventos personalizados ({{count}})`,
      descriptionPlaceholder: `Descripción opcional para este horario`,
      namePlaceholder: `Horario comercial`,
      timezoneWarning: `Esto actualizará tus horas semanales a la zona horaria seleccionada.`,
      title: `Editar horario`,
      updateSchedule: `Actualizar horario`,
      validation: {
        nameRequired: `Ingresa un nombre para el horario`,
      },
    },
    override: {
      dateTime: `Fecha y hora`,
      dateType: {
        multipleDays: `Varios días`,
        singleDay: `Un día`,
      },
      endRepeat: `Finalizar repetición`,
      irregularRepeat: `Esta excepción tiene patrones de repetición irregulares y no puede editarse`,
      irregularRepeatNamed: `{{name}} tiene un patrón de repetición que no se puede editar.`,
      irregularRepeatNextOccurrence: `La próxima ocurrencia es {{occurrence}}`,
      holidayTemplateCheckPending: `Comprobando el patrón de repetición de {{name}}. Los controles de fecha y repetición no están disponibles temporalmente.`,
      holidayTemplateCheckUnavailable: `No se pudo verificar el patrón de repetición de {{name}}. Los controles de fecha y repetición no están disponibles.`,
      loadingDetails: `Cargando detalles de la excepción...`,
      monthly: {
        nthWeekday: `El {{nth}}{{suffix}} {{weekday}}`,
        specificDate: `El {{day}}{{suffix}}`,
      },
      namePlaceholder: `Nombre de la excepción`,
      startTimeAriaLabel: `Hora de inicio`,
      startDateAriaLabel: `Fecha de inicio`,
      endDateAriaLabel: `Fecha de fin`,
      endRepeatDateAriaLabel: `Fecha de fin de la repetición`,
      endTimeAriaLabel: `Hora de fin`,
      timePlaceholder: `h:mm`,
      meridiemAriaLabel: `{{label}}: a. m./p. m.`,
      meridiemOptionsAriaLabel: `{{label}}: opciones de a. m./p. m.`,
      timeOptionsAriaLabel: `{{label}}: opciones`,
      occurrences: `ocurrencias`,
      repeat: `Repetir`,
      repeatEvery: `Repetir cada`,
      repeatOn: `Repetir en`,
      repeatUnit: {
        days: `día(s)`,
        months: `mes(es)`,
        weeks: `semana(s)`,
        years: `año(s)`,
      },
      timeType: {
        closedAllDay: `Cerrado todo el día`,
        setClosedHours: `Definir horario de cierre`,
      },
      titleCreate: `Agregar excepción`,
      titleEdit: `Editar excepción de horario`,
      validation: {
        endAfterStart: `La fecha/hora de finalización debe ser posterior a la de inicio`,
        endDateRequired: `Selecciona una fecha de fin para eventos de varios días`,
        endDateRequiredShort: `Selecciona una fecha de fin`,
        invalidDateTime: `Ingresa valores válidos de fecha y hora`,
        monthRequired: `Selecciona un mes para repetición anual`,
        monthlyPatternRequired: `Selecciona un patrón de repetición mensual`,
        nameRequired: `Ingresa un nombre para la excepción`,
        occurrencesRequired: `Ingresa el número de ocurrencias`,
        startEndTimeRequired: `Selecciona hora de inicio y fin`,
        validDayRequired: `Selecciona un día válido (1-31)`,
        validWeekdayPatternRequired: `Selecciona un patrón de día de semana válido`,
        weekdayRequired: `Selecciona al menos un día de la semana`,
      },
      yearly: {
        nthWeekday: `El {{nth}}{{suffix}} {{weekday}} de {{month}}`,
        specificDate: `El {{day}}{{suffix}} de {{month}}`,
      },
    },
  },
  overrides: {
    actions: {
      addHoliday: `Agregar festivo`,
      addOverride: `Agregar excepción`,
    },
    empty: `No hay excepciones de horario configuradas`,
    item: {
      deleteHolidayTitle: `Eliminar festivo`,
      deleteOverrideModalTitle: `Eliminar excepción`,
      deleteOverrideTitle: `Eliminar excepción`,
      editOverrideTitle: `Editar excepción`,
      overrideInEffect: `Excepción en efecto`,
      repeatsPrefix: `Se repite`,
    },
    title: `Excepciones de horario`,
  },
  status: {
    closed: `Cerrado`,
    holiday: `Festivo`,
    open: `Abierto`,
  },
  weeklyHours: {
    calendar: {
      confirmCreateDescription: `¿Crear una nueva entrada de horario para este rango seleccionado?`,
      confirmCreateTitle: `Crear entrada de horario`,
      confirmDeleteTitle: `Eliminar franja horaria`,
      deleteEventLabel: `Eliminar {{day}} {{time}}`,
    },
    table: {
      confirmDeleteDayDescription: `¿Seguro que deseas eliminar todas las franjas horarias de {{day}}? Esta acción no se puede deshacer.`,
      confirmDeleteDayItem: `horas semanales de {{day}}`,
      confirmDeleteDayTitle: `Eliminar franja horaria`,
      confirmDeleteSlotItem: `franja horaria de {{day}}`,
      confirmDeleteSlotTitle: `Eliminar franja horaria`,
      days: {
        friday: `Viernes`,
        monday: `Lunes`,
        saturday: `Sábados`,
        sunday: `Domingos`,
        thursday: `Jueves`,
        tuesday: `Martes`,
        wednesday: `Miércoles`,
      },
      slot: {
        addTitle: `Agregar entrada de horario`,
        addDayLabel: `Agregar horas del {{day}}`,
        deleteTitle: `Eliminar entrada de horario`,
        deleteSlotLabel: `Eliminar horas del {{day}} de {{start}} a {{end}}`,
        endPlaceholder: `Fin`,
        startPlaceholder: `Inicio`,
        startTimeLabel: `Hora de inicio del {{day}}`,
        startTimeLabelNumbered: `Hora de inicio del {{day}}, entrada {{number}}`,
        endTimeLabel: `Hora de fin del {{day}}`,
        endTimeLabelNumbered: `Hora de fin del {{day}}, entrada {{number}}`,
        unavailable: `No disponible`,
      },
      toggle: {
        disableDay: `Desactivar {{day}}`,
        enableDay: `Activar {{day}}`,
      },
    },
    timeSelect: {
      noTimesFound: `No se encontraron horas`,
    },
  },

  queryError: {
    fetchSchedules: `Error al obtener los horarios`,
    fetchSchedule: `Error al obtener el horario`,
    fetchEvents: `Error al obtener los eventos del horario`,
    fetchHolidays: `Error al obtener los días festivos del horario`,
    createSchedule: `Error al crear el horario`,
    updateSchedule: `Error al actualizar el horario`,
    createEvent: `Error al crear el evento del horario`,
    updateEvent: `Error al actualizar el evento del horario`,
    deleteEvent: `Error al eliminar el evento del horario`,
    generic: `Algo salió mal. Inténtalo de nuevo.`,
  },
}
